<ng-container *transloco="let t;">
<!-- Add New Template Modal -->
    <div class="modal-header">
        <h4 class="modal-title">{{ t('Template listing - Add new template (modal - title) - Add new template') }}</h4>
        <button type="button" class="close" (click)="modalService.close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    </div>
    <form [formGroup]="add_template_form" (ngSubmit)="addNewTemplate()">
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="form-group">
                <label>{{ t('Template name - field title (general) - Template name') }} </label>
                <div class="form-group">
                    <input formControlName="name" type="text" placeholder="{{ t('Template placeholder text (Add new template modal) - e.g. Sales Agreement') }}" class="form-control" [ngClass]="{ 'is-invalid error': submitted && add_template_form.controls.name.errors }"/>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button [disabled]="addTemaplteLoadder" type="button" class="btn btn-outline-secondary" (click)="modalService.dismiss('Cross click')" rippleEffect>
        {{ t('Cancel button text (cancel button) - cancel') }}
    </button>
            <button [disabled]="addTemaplteLoadder" type="submit" class="btn btn-success" rippleEffect>
        <span *ngIf="addTemaplteLoadder" class="spinner-border spinner-border-sm me-1"></span> {{ t('Save button text (save button) - save') }}
    </button>
        </div>
    </form>
<!-- / Add New Template Modal -->
</ng-container>